import { useCallback } from 'react';
import { ButtonSupport } from '@/components/buttons';
import { Intercom } from '@/hooks/3dParty/intercom';

export const Support = () => {
  const handleButtonClick = useCallback(() => {
    Intercom.openChat();
  }, []);

  return (
    <ButtonSupport id="intercomcustomLauncher" onClick={handleButtonClick} />
  );
};
